import React from 'react';
import { IndexedTitleV2 } from '@warehouse/graphql';
import { SearchInput } from '@warehouse/shared/ui';
import styled, { css } from 'styled-components';
import { ChildTable } from './ui/ChildTable';
import { ChildrenListProps } from './types';
import { useChildrenListStore } from './domain/children.store';
import { childTableStoreSelector } from './domain/children-table.store.selectors';
import { LoaderWrapper } from '../../../src/components/library/LoaderWrapper';

export function ChildrenListFeature({
	label,
	title,
	searchInputAction,
	onChildrenClick,
	childWorkType,
	disableVirtualization,
}: ChildrenListProps) {
	const isPending = useChildrenListStore(childTableStoreSelector.isPending);

	return (
		<>
			<TopRow>
				<SearchInput label={label} />
				{searchInputAction}
			</TopRow>
			<LoaderWrapper loading={isPending} opacity={0.3} style={{ flex: 1 }}>
				<ChildTable
					title={title}
					childWorkType={childWorkType}
					onClickRow={(row: IndexedTitleV2) => onChildrenClick?.(row)}
					disableVirtualization={disableVirtualization}
				/>
			</LoaderWrapper>
		</>
	);
}

const TopRow = styled.div(
	({ theme }) => css`
		align-items: center;
		display: flex;
		gap: ${theme.spacing(2)};
		width: 100%;
	`,
);
